/**
 * WEB-756 — the single row source for every lexicon entry that routes
 * through `GenericModule` (`generic` and `agenda`).
 *
 * Always empty today: none of those kinds has a structured backing column
 * on `EventDetailV2` (WEB-749 design spec §5.2). Wiring a real source later
 * is a change inside this one function — `hasModuleContent` in `modules.ts`
 * reads `.length`, so `hasContent` and "has rows" cannot drift.
 *
 * Lives next to `resolveEventModules` (not in the renderer) so the selector
 * can fold row-emptiness into `hasContent` without importing a React
 * component. `GenericModule` re-exports this name so existing test imports
 * keep working.
 */

import type { EventDetailV2 } from '@/types/eventDetail';

/**
 * The row source for `generic` and `agenda`. Always empty today — see the
 * file header. Exported as its own named function (rather than inlined) so
 * a future contract change that adds a real backing column touches exactly
 * this body, and so the "always empty today" contract is something a test
 * can name and assert directly.
 */
export function resolveGenericModuleRows(_event: EventDetailV2): readonly [] {
  return [];
}
